<template>
    <div class="content">
        <span>{{title}}</span>
        <div class="more" @click="go">更多</div>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type: String,
            default: () => 'IFM活动',
        }
    },
    methods: {
        go(){
            switch(this.title) {
                case 'IFM新闻':
                    this.$router.push('/info?type=0');
                    break;
                case 'IFM活动':
                    this.$router.push('/ifmMember');
                    break;
            } 
        }
    },
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    position: relative;
    span{
        font-size: 22px;
        color: #333333;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
    .more{
        position: absolute;
        font-size: 14px;
        color: #3B3B3B;
        letter-spacing: 0.4px;
        font-weight: 400;
        right: 0px;
        top: 4px;
        cursor: pointer;
    }
}
</style>
